import { message } from 'ant-design-vue';
import axios from 'axios';
import qs from 'qs';

import instance from '../main';

const appBaseURL = process.env.VUE_APP_API_BASE_URL;

class BaseModule {
  constructor(baseURL = appBaseURL) {
    this.$http = axios.create({
      baseURL,
    });
    this.$http.interceptors.request.use(
      config => {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return config;
      },
      error => Promise.reject(error)
    );
    this.$http.interceptors.response.use(
      response => {
        if (response.data.code == 2002) {
          instance.$store.commit('user/setToken', null);
          instance.$store.commit('user/setInfo', null);
          instance.$router.push({ name: 'Login' });
        }
        if (response.data.code !== 0) {
          message.error(response.data.msg);
          return Promise.reject(response.data);
        }
        return Promise.resolve(response.data);
      },
      error => {
        return Promise.reject(error);
      }
    );
  }

  get(url, config = {}) {
    return this.$http.get(url, config);
  }

  post(url, data = undefined, config = {}) {
    console.log('=========', url);
    return this.$http.post(
      url,
      qs.stringify({ ...data, token: instance.$store.state.user.token, sign: 'test', time: Date.parse(new Date()) }),
      config
    );
  }

  put(url, data = undefined, config = {}) {
    return this.$http.put(
      url,
      qs.stringify({ ...data, token: instance.$store.state.user.token, sign: 'test', time: Date.parse(new Date()) }),
      config
    );
  }

  delete(url, config = {}) {
    return this.$http.delete(url, config);
  }
}

export default BaseModule;
